import type { IQuoteVMProps } from '@data/view-models';
import type { IApiRequestProps } from '@core/utils/api';
import type { TQueryKey } from '@react/utils/queryHooks';

import { api } from './api';

export const QK_FETCH_QUOTES: TQueryKey = 'qk_fetchQuotes';

function getQuotes({ signal }: IApiRequestProps): Promise<IQuoteVMProps[]> {
  return api.get<IQuoteVMProps[]>({
    signal,
    endpoint: 'quotes',
  });
}

export const quoteApi = {
  getQuotes,
};
